import { render, staticRenderFns } from "./Entrega.vue?vue&type=template&id=1a3fd190&scoped=true"
import script from "./Entrega.vue?vue&type=script&lang=js"
export * from "./Entrega.vue?vue&type=script&lang=js"
import style0 from "./Entrega.vue?vue&type=style&index=0&id=1a3fd190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3fd190",
  null
  
)

export default component.exports